import React from 'react';
import RsvpService from '../../../../services/RsvpService';
import { __, STR_KEY } from '../../../../services/Translate';
import GoogleMap from '../../../Map';

export const getLocationTitle = (sessionLocation, eventLocation, legacyTitle) => {
	return (sessionLocation || {}).title || (eventLocation || {}).title || legacyTitle || null;
}

export const getLocationAddress = (sessionLocation, eventLocation, legacyAddress) => {
    return (sessionLocation || {}).address || (eventLocation || {}).address || legacyAddress || null;
}

export const mapsSelector = (sessionLocation, eventLocation) => {
    const lat = (sessionLocation || {}).lat || (eventLocation || {}).lat || null;
    const lng = (sessionLocation || {}).lng || (eventLocation || {}).lng || null;

    if (!lat || !lng) return false;

    let url;
    if (navigator.platform.includes("iPhone") || navigator.platform.includes("iPod") || navigator.platform.includes("iPad")) {
    	url = `maps://maps.google.com/maps?saddr=My+Location&daddr=${lat},${lng}&amp;ll=`;
    } else {
    	url = `https://maps.google.com/maps?saddr=My+Location&daddr=${lat},${lng}&amp;ll=`;
    }

    return window.open(url);
}

export function Location({session, sessionLocation, eventLocation}) {

	if (RsvpService.isOnline(session)) return null;

	let title = null;
    const lat = (sessionLocation || {}).lat || (eventLocation || {}).lat || null;
    const lng = (sessionLocation || {}).lng || (eventLocation || {}).lng || null;
    if ((sessionLocation || {}).title) {
    	title = `${sessionLocation.title}, ${sessionLocation.address}`;
    } else if ((eventLocation || {}).title) {
    	title = `${eventLocation.title}, ${eventLocation.address}`;
    }

    if (!lat || !lng) return null;

    return (
        <div className="sessionMap section">
            <div className="row">
                <div className="col col-12 sectionLabel" role="heading" aria-level="2">
					{__(STR_KEY.MODAL_SESSION_LOCATION)}
                </div>
                <div className="col">
                    <GoogleMap
                        lat={lat}
                        lng={lng}
                        title={title}
                    />
                </div>
                <div className="col col-12 sessionDirection" 
					tabIndex={0} 
					role='link'
					onKeyDown={({keyCode}) => {
						if (keyCode === 13){
							mapsSelector(sessionLocation, eventLocation);
						}
					}}>
                    <a onClick={() => {mapsSelector(sessionLocation, eventLocation)}}>
                        <i className="far fa-location-arrow"></i> {__(STR_KEY.MODAL_SESSION_TITLE_DIRECTIONS)}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Location;